<template>
  <Toolbar classes="pt-3">
    <template v-slot:actions>
      <div class="d-flex align-items-center flex-wrap gap-2">
        <button class="btn btn-sm btn-light" @click="$router.push('/whatsapp')">
          <i class="bi bi-arrow-left me-2"></i>
          Voltar
        </button>
        <button class="btn btn-sm btn-secondary" @click="syncTemplates">
          <i class="bi bi-arrow-clockwise me-1"></i>
          Sincronizar com WhatsApp
        </button>
        <button class="btn btn-sm btn-primary" @click="openCreateModal">
          Novo Template
        </button>
      </div>
    </template>
  </Toolbar>

  <div class="container-xxl">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <div class="d-flex align-items-center position-relative my-1">
            <span class="svg-icon svg-icon-1 position-absolute ms-6">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1"
                      transform="rotate(45 17.0365 15.1223)" fill="black"></rect>
                <path
                  d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z"
                  fill="black"></path>
              </svg>
            </span>
            <input type="search" v-model="search"
                   class="form-control form-control-solid w-250px ps-14"
                   placeholder="Pesquisar templates...">
          </div>
        </div>
      </div>
      <div class="card-body py-4">
        <div class="table-responsive">
          <table class="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
            <thead>
              <tr class="fw-bold text-muted">
                <th class="min-w-150px">Nome</th>
                <th class="min-w-200px">Conteúdo</th>
                <th class="min-w-100px text-center">Status</th>
                <th class="min-w-120px text-center">WhatsApp</th>
                <th class="min-w-150px text-end">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="template in filteredTemplates" :key="template.id_whatsapp_template">
                <td>
                  <span class="text-dark fw-bold d-block fs-6">{{ template.template_name }}</span>
                </td>
                <td>
                  <span class="text-muted fw-semibold d-block fs-7">
                    {{ truncateContent(template.template_content) }}
                  </span>
                </td>
                <td class="text-center">
                  <span :class="template.template_active ? 'badge badge-success' : 'badge badge-danger'">
                    {{ template.template_active ? 'Ativo' : 'Inativo' }}
                  </span>
                </td>
                <td class="text-center">
                  <div v-if="template.is_whatsapp_template">
                    <span :class="getWhatsAppStatusBadgeClass(template.whatsapp_template_status)">
                      {{ getWhatsAppStatusLabel(template.whatsapp_template_status) }}
                    </span>
                    <div v-if="template.template_category" class="small text-muted mt-1">
                      {{ template.template_category }}
                    </div>
                  </div>
                  <span v-else class="text-muted small">Não é template WhatsApp</span>
                </td>
                <td class="text-end">
                  <div class="d-flex align-items-center justify-content-end gap-1">
                    <button v-if="template.is_whatsapp_template && template.whatsapp_template_status === 'pending'"
                            class="btn btn-icon btn-bg-light btn-active-color-info btn-sm"
                            @click="checkTemplateStatus(template)" title="Verificar Status">
                      <i class="bi bi-arrow-clockwise"></i>
                    </button>
                    <button class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
                            @click="editTemplate(template)" title="Editar">
                      <i class="bi bi-pencil"></i>
                    </button>
                    <button class="btn btn-icon btn-bg-light btn-active-color-danger btn-sm"
                            @click="deleteTemplate(template)" title="Deletar">
                      <i class="bi bi-trash"></i>
                    </button>
                  </div>
                </td>
              </tr>
              <tr v-if="filteredTemplates.length === 0">
                <td colspan="5" class="text-center text-muted py-10">
                  Nenhum template encontrado
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="modal fade" id="templateModal" tabindex="-1" aria-labelledby="templateModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="templateModalLabel">{{ editingTemplate ? 'Editar Template' : 'Novo Template' }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fechar"></button>
          </div>
          <form @submit.prevent="saveTemplate">
            <div class="modal-body">
              <div class="mb-5">
                <label class="form-label required">Nome do Template</label>
                <input type="text" v-model="form.template_name" class="form-control" required maxlength="100"
                       placeholder="Ex: Finalização de Atendimento">
              </div>
              <div class="mb-5">
                <label class="form-label required">Conteúdo</label>
                <textarea 
                  ref="templateContentTextarea"
                  v-model="form.template_content" 
                  class="form-control" 
                  rows="6" 
                  required
                  placeholder="Digite o conteúdo da mensagem..."
                  @focus="showFormattingToolbar = true"
                ></textarea>
                <div class="d-flex justify-content-end mt-2">
                  <div class="formatting-toolbar">
                    <button 
                      type="button" 
                      class="btn btn-sm btn-light me-1" 
                      @click="toggleEmojiPicker"
                      title="Inserir emoji"
                    >
                      <i class="bi bi-emoji-smile"></i>
                    </button>
                    <button 
                      type="button" 
                      class="btn btn-sm btn-light me-1" 
                      @click="insertFormatting('bold')"
                      title="Negrito"
                    >
                      <strong>B</strong>
                    </button>
                    <button 
                      type="button" 
                      class="btn btn-sm btn-light me-1" 
                      @click="insertFormatting('italic')"
                      title="Itálico"
                    >
                      <em>I</em>
                    </button>
                    <button 
                      type="button" 
                      class="btn btn-sm btn-light me-1" 
                      @click="insertFormatting('underline')"
                      title="Sublinhado"
                    >
                      <u>U</u>
                    </button>
                    <button 
                      type="button" 
                      class="btn btn-sm btn-light" 
                      @click="insertVariable"
                      title="Inserir variável"
                    >
                      <i class="bi bi-hash"></i> Variável
                    </button>
                  </div>
                </div>
                <EmojiPicker
                  :visible="showEmojiPicker"
                  container-class="position-relative"
                  picker-class="emoji-picker-right"
                  @select="insertEmoji"
                />
                <div class="form-text">
                  Dica: Para adicionar um link, use o formato: [Texto do botão](https://exemplo.com)
                </div>
              </div>
              <div class="mb-5">
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" v-model="form.template_active" id="templateActive">
                  <label class="form-check-label" for="templateActive">
                    Template ativo
                  </label>
                </div>
              </div>
              <div class="mb-5">
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" v-model="form.is_whatsapp_template" id="isWhatsAppTemplate" :disabled="editingTemplate && editingTemplate.is_whatsapp_template">
                  <label class="form-check-label" for="isWhatsAppTemplate">
                    Template do WhatsApp
                  </label>
                </div>
                <div class="form-text">Marque se este template será usado para mensagens iniciadas pela clínica (após 24h sem interação)</div>
              </div>
              <div v-if="form.is_whatsapp_template && !editingTemplate" class="mb-5">
                <label class="form-label required">Categoria do Template</label>
                <select v-model="form.template_category" class="form-select" required>
                  <option value="">Selecione uma categoria</option>
                  <option value="UTILITY">UTILITY - Informações transacionais</option>
                  <option value="MARKETING">MARKETING - Promoções e marketing</option>
                  <option value="AUTHENTICATION">AUTHENTICATION - Códigos de verificação</option>
                </select>
                <div class="form-text">A categoria é necessária para criar o template no WhatsApp</div>
              </div>
              <div v-if="editingTemplate && editingTemplate.is_whatsapp_template" class="mb-5">
                <label class="form-label">Categoria do Template</label>
                <input type="text" :value="editingTemplate.template_category || form.template_category" class="form-control" readonly>
                <div class="form-text">A categoria não pode ser alterada após o template ser criado no WhatsApp</div>
              </div>
              <div v-if="editingTemplate && editingTemplate.is_whatsapp_template" class="mb-5">
                <div class="alert alert-info">
                  <i class="bi bi-info-circle me-2"></i>
                  <strong>Status:</strong> {{ getWhatsAppStatusLabel(editingTemplate.whatsapp_template_status) }}
                  <span v-if="editingTemplate.whatsapp_template_status === 'pending'" class="ms-2">
                    <button class="btn btn-sm btn-outline-info" @click.prevent="checkTemplateStatus(editingTemplate)">
                      Verificar Status
                    </button>
                  </span>
                </div>
              </div>
              <div v-if="form.template_content" class="card bg-light">
                <div class="card-body">
                  <strong>Preview:</strong>
                  <div class="mt-2" style="white-space: pre-wrap;">{{ form.template_content }}</div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancelar</button>
              <button type="submit" class="btn btn-primary">Salvar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Toolbar from "@/components/layouts/auth/Toolbar.vue";
import EmojiPicker from "@/components/whatsapp/EmojiPicker.vue";
import http from "@/helpers/http";
import Alert from "@/helpers/alert";
import Modal from "@/helpers/modal";
import whatsappService from "@/service/whatsappService";

export default {
  name: "WhatsAppTemplates",
  components: {
    Toolbar,
    EmojiPicker,
  },
  data() {
    return {
      templates: [],
      search: "",
      editingTemplate: null,
      form: {
        template_name: "",
        template_content: "",
        template_active: true,
      },
      showEmojiPicker: false,
      showFormattingToolbar: false,
    };
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
    filteredTemplates() {
      if (!this.search) {
        return this.templates;
      }
      const searchLower = this.search.toLowerCase();
      return this.templates.filter(t => 
        t.template_name.toLowerCase().includes(searchLower) ||
        t.template_content.toLowerCase().includes(searchLower)
      );
    },
  },
  mounted() {
    this.loadTemplates();
  },
  methods: {
    async loadTemplates() {
      try {
        this.templates = await whatsappService.getTemplates(this.place.id_place);
      } catch (error) {
        Alert.error("Erro ao carregar templates");
      }
    },
    openCreateModal() {
      this.editingTemplate = null;
      this.form = {
        template_name: "",
        template_content: "",
        template_active: true,
        is_whatsapp_template: false,
        template_category: "",
      };
      Modal.toggle("#templateModal");
    },
    editTemplate(template) {
      this.editingTemplate = template;
      this.form = {
        template_name: template.template_name,
        template_content: template.template_content,
        template_active: template.template_active,
        is_whatsapp_template: template.is_whatsapp_template || false,
        template_category: template.template_category || "",
      };
      Modal.toggle("#templateModal");
    },
    async saveTemplate() {
      try {
        if (this.editingTemplate) {
          await whatsappService.updateTemplate(
            this.place.id_place,
            this.editingTemplate.id_whatsapp_template,
            this.form
          );
          Alert.success("Template atualizado com sucesso");
        } else {
          const createdTemplate = await whatsappService.createTemplate(this.place.id_place, this.form);
          
          if (this.form.is_whatsapp_template && this.form.template_category) {
            try {
              await this.createWhatsAppTemplate(createdTemplate.id_whatsapp_template);
            } catch (error) {
              console.error("Erro ao criar template no WhatsApp:", error);
              Alert.warning("Template criado localmente, mas houve erro ao criar no WhatsApp. Você pode tentar novamente depois.");
            }
          }
          
          Alert.success("Template criado com sucesso");
        }
        Modal.toggle("#templateModal");
        this.loadTemplates();
      } catch (error) {
        Alert.error("Erro ao salvar template");
      }
    },
    async deleteTemplate(template) {
      const result = await Swal.fire({
        title: 'Confirmar exclusão',
        text: `Deseja realmente deletar o template "${template.template_name}"?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#dc3545',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Sim, deletar',
        cancelButtonText: 'Cancelar',
      });

      if (!result.isConfirmed) {
        return;
      }

      try {
        await whatsappService.deleteTemplate(
          this.place.id_place,
          template.id_whatsapp_template
        );
        Alert.success("Template deletado com sucesso");
        this.loadTemplates();
      } catch (error) {
        Alert.error("Erro ao deletar template");
      }
    },
    truncateContent(content) {
      if (content.length > 100) {
        return content.substring(0, 100) + "...";
      }
      return content;
    },
    async createWhatsAppTemplate(templateId) {
      let template = this.templates.find(t => t.id_whatsapp_template === templateId);
      
      if (!template) {
        const allTemplates = await whatsappService.getTemplates(this.place.id_place);
        template = allTemplates.find(t => t.id_whatsapp_template === templateId);
      }
      
      if (!template) {
        throw new Error("Template não encontrado");
      }

      const components = [];
      const content = template.template_content || "";
      
      if (content.trim()) {
        components.push({
          type: "BODY",
          text: content
        });
      }

      await http.post(`/places/${this.place.id_place}/whatsapp/templates/create-whatsapp`, {
        template_id: templateId,
        category: this.form.template_category,
        language: "pt_BR",
        components: components,
      });

      Alert.success("Template criado no WhatsApp e aguardando aprovação");
      this.loadTemplates();
    },
    async syncTemplates() {
      try {
        await http.post(`/places/${this.place.id_place}/whatsapp/templates/sync`);
        Alert.success("Templates sincronizados com sucesso");
        this.loadTemplates();
      } catch (error) {
        Alert.error("Erro ao sincronizar templates");
      }
    },
    async checkTemplateStatus(template) {
      try {
        await http.get(`/places/${this.place.id_place}/whatsapp/templates/${template.id_whatsapp_template}/status`);
        Alert.success("Status verificado");
        this.loadTemplates();
      } catch (error) {
        Alert.error("Erro ao verificar status do template");
      }
    },
    getWhatsAppStatusLabel(status) {
      const labels = {
        pending: "Aguardando Aprovação",
        approved: "Aprovado",
        rejected: "Rejeitado",
      };
      return labels[status] || "Desconhecido";
    },
    getWhatsAppStatusBadgeClass(status) {
      const classes = {
        pending: "badge badge-warning",
        approved: "badge badge-success",
        rejected: "badge badge-danger",
      };
      return classes[status] || "badge badge-secondary";
    },
    setupModal() {
      const modalElement = document.getElementById('templateModal');
      if (modalElement) {
        modalElement.addEventListener('shown.bs.modal', () => {
          modalElement.removeAttribute('aria-hidden');
        });
        modalElement.addEventListener('hidden.bs.modal', () => {
          modalElement.setAttribute('aria-hidden', 'true');
          this.showEmojiPicker = false;
        });
      }
    },
    toggleEmojiPicker() {
      this.showEmojiPicker = !this.showEmojiPicker;
    },
    insertEmoji(emoji) {
      this.insertTextAtCursor(emoji);
      this.showEmojiPicker = false;
    },
    insertFormatting(type) {
      const textarea = this.$refs.templateContentTextarea;
      if (!textarea) return;

      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const selectedText = this.form.template_content.substring(start, end);
      const beforeText = this.form.template_content.substring(0, start);
      const afterText = this.form.template_content.substring(end);

      let formattedText = '';
      let newCursorPos = start;

      switch (type) {
        case 'bold':
          formattedText = selectedText ? `**${selectedText}**` : '**texto**';
          newCursorPos = selectedText ? start + 2 : start + 2;
          break;
        case 'italic':
          formattedText = selectedText ? `*${selectedText}*` : '*texto*';
          newCursorPos = selectedText ? start + 1 : start + 1;
          break;
        case 'underline':
          formattedText = selectedText ? `__${selectedText}__` : '__texto__';
          newCursorPos = selectedText ? start + 2 : start + 2;
          break;
      }

      this.form.template_content = beforeText + formattedText + afterText;
      
      this.$nextTick(() => {
        textarea.focus();
        if (selectedText) {
          textarea.setSelectionRange(newCursorPos, newCursorPos + selectedText.length);
        } else {
          textarea.setSelectionRange(newCursorPos, newCursorPos + (type === 'bold' || type === 'underline' ? 6 : 5));
        }
      });
    },
    insertVariable() {
      const textarea = this.$refs.templateContentTextarea;
      if (!textarea) return;

      const start = textarea.selectionStart;
      const beforeText = this.form.template_content.substring(0, start);
      const afterText = this.form.template_content.substring(start);

      const existingVars = this.form.template_content.match(/\{\{(\d+)\}\}/g) || [];
      const nextVarNum = existingVars.length + 1;
      const variable = `{{${nextVarNum}}}`;

      this.form.template_content = beforeText + variable + afterText;
      
      this.$nextTick(() => {
        textarea.focus();
        textarea.setSelectionRange(start + variable.length, start + variable.length);
      });
    },
    insertTextAtCursor(text) {
      const textarea = this.$refs.templateContentTextarea;
      if (!textarea) return;

      const start = textarea.selectionStart;
      const beforeText = this.form.template_content.substring(0, start);
      const afterText = this.form.template_content.substring(start);

      this.form.template_content = beforeText + text + afterText;
      
      this.$nextTick(() => {
        textarea.focus();
        textarea.setSelectionRange(start + text.length, start + text.length);
      });
    },
  },
};
</script>

<style scoped>
.formatting-toolbar {
  display: flex;
  align-items: center;
  gap: 4px;
}

.formatting-toolbar .btn {
  padding: 4px 8px;
  font-size: 0.875rem;
}


.required::after {
  content: " *";
  color: red;
}
</style>

